
<template>
    <div style="width:100%;height:100%">
         <buttonlist
                 @help="help" ref="SetBtn"
        ></buttonlist>
        <el-card class="box-card">
            <el-row style="display: flex;background: white">
                <el-button type="primary" size="mini" @click="showitems">{{$t('getapi[438]')}}</el-button>
                <el-button type="primary" size="mini" @click="remove">{{$t('getapi[437]')}}</el-button>
                <el-col :span="6" style="text-align: left">
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[4410]')}}</el-button>
                    </el-upload>
                </el-col>
                <el-col :span="18" style="text-align: right">
                    <el-button type="primary" size="mini" @click="getTemplate">{{$t('getapi[6118]')}}</el-button>
                    <!--<el-button type="primary" size="mini" @click="showitems">添加</el-button>
                    <el-button type="primary" size="mini" @click="remove">移除</el-button>-->
                    <el-button type="primary" size="mini" @click="update" :disabled="!btn.upd">{{$t('getapi[1716]')}}</el-button>
                    <!--<el-button type="primary" size="mini">关闭</el-button>-->
                </el-col>
            </el-row>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix"><span>{{$t('getapi[1709]')}}</span></div>
            <el-table
                    :data="dataSet"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    size="mini"
                    :height="tableHeight"
                    header-row-class-name="headerclass"
                    tab-click="selectInfo(0)"
                    :row-class-name="tableRowClassName"
                    @selection-change="handleSelectionChange"
                    style="width: 100%; margin-top:0px"
                    ref="singleTable"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip sortable prop="exclusively_id" label="ID" v-if="false"></el-table-column>
                <el-table-column show-overflow-tooltip sortable prop="state" :label="$t('getapi[552]')"></el-table-column>
                <el-table-column show-overflow-tooltip sortable prop="PO_Code" :label="$t('getapi[1710]')"></el-table-column>
                <el-table-column show-overflow-tooltip sortable prop="line_no" :label="$t('getapi[1711]')"></el-table-column>
                <el-table-column show-overflow-tooltip sortable prop="Part_Code" :label="$t('getapi[112]')"></el-table-column>
                <el-table-column show-overflow-tooltip sortable prop="Part_version" :label="$t('getapi[149]')"></el-table-column>
                <el-table-column sortable prop="old_date" :label="$t('getapi[13168]')">
                    <template scope="scope">
                        {{scope.row.old_date | toDate}}
                    </template>
                </el-table-column>
                <el-table-column sortable prop="new_date" :label="$t('getapi[13169]')">
                    <template scope="scope">
                        <el-date-picker size="mini" sortable type="date" v-model="scope.row.new_date"></el-date-picker>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <!--<order :isVisible="itevisible" @getorder="getorder" ref="order"></order>-->

        <selector :isVisible="false" :isBatch=true :selectType="3" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPurOrderDataList'" @callback="getorder" ref="order"></selector>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
		name:'purorderbatchchange',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-210
            }
        },
        data() {
            return {
                user: "",
                itevisible: false,
                dataSet: [],
                dataChecked: [], // 选中的ID集合
                loading: false, // 主表加载状态
                uploadurl: '',
                fileList: [],
                editPlan: '0',
                editPlanList: [
                    {
                        value: '0',
                        label: this.$t('getapi[852]')//'未选择'
                    },
                    {
                        value: 'planning_CODE',
                        label: this.$t('getapi[3628]')//'计划类型'
                    },
                    {
                        value: 'LEAST_PURCH_BATCH',
                        label: this.$t('getapi[152]')//'最小订购批量'
                    },
                    {
                        value: 'STOCK_LOWERLIMIT',
                        label: this.$t('getapi[2548]')//'安全库存'
                    },
                    {
                        value: 'PURCHASE_LEADTIME',
                        label: this.$t('getapi[158]')//'采购提前期'
                    },
                    {
                        value: 'Produce_LEADTIME',
                        label: this.$t('getapi[161]')//'生产提前期'
                    },
                    {
                        value: 'MergeDays',
                        label: this.$t('getapi[153]')//'合并天数'
                    },
                    {
                        value: 'Standard_BATCH',
                        label: this.$t('getapi[159]')//'标准批量'
                    },
                    {
                        value: 'Products',
                        label: this.$t('getapi[145]')//'所属产品'
                    },
                    {
                        value: 'Planner_Name',
                        label: this.$t('getapi[163]')//'计划员'
                    },
                    {
                        value: 'Package_Qty',
                        label: this.$t('getapi[164]')//'订单增量'
                    },
                    {
                        value: 'STOCK_UPPERLIMIT',
                        label: this.$t('getapi[156]')//'库存上限'
                    },
                    {
                        value: 'saledemandflag',
                        label: this.$t('getapi[166]')//'客户订单限制'
                    },
                    {
                        value: 'CYCLE_CHECK_INTERVAL',
                        label: this.$t('getapi[151]')//'循环盘点间隔'
                    },
                    {
                        value: 'REQUIRE_PERIOD',
                        label: this.$t('getapi[154]')//'需求时界'
                    },
                    {
                        value: 'PLANNING_PERIOD',
                        label: this.$t('getapi[155]')//'计划时界'
                    },
                    {
                        value: 'Year_BATCH',
                        label: this.$t('getapi[160]')//'年用量'
                    },
                    {
                        value: 'DigitScale',
                        label: this.$t('getapi[165]')//'圆整率'
                    },
                    {
                        value: 'QC_Leadtime',
                        label: this.$t('getapi[6006]')//'质检天数'
                    },
                    {
                        value: 'So_Issue_control',
                        label: this.$t('getapi[6007]')//'控制发料'
                    },
                    {
                        value: 'Safe_days',
                        label: this.$t('getapi[6008]')//'取值天数'
                    },
                    {
                        value: 'STOCK_LOWEST',
                        label: this.$t('getapi[6009]')//'订购点'
                    }
                ],
                planning_CODE: [
                    {
                        value: 'MRP',
                        label: 'MRP'
                    },
                    {
                        value: '人工',
                        label: this.$t('getapi[8624]')//'人工'
                    },
                    {
                        value: '订购点',
                        label: this.$t('getapi[6009]')//'订购点'
                    },
                    {
                        value: 'VMI',
                        label: 'VMI'
                    },
                    {
                        value: 'MPS',
                        label: 'MPS'
                    },
                    {
                        value: '客户供应',
                        label: this.$t('getapi[884]')//'客户供应'
                    }
                ],
                saledemandflag: [
                    {
                        value: '否',
                        label: this.$t('getapi[2053]')//'否'
                    },
                    {
                        value: '是',
                        label: this.$t('getapi[2052]')//'是'
                    }
                ],
                So_Issue_control: [
                    {
                        value: '否',
                        label: this.$t('getapi[2053]')//'否'
                    },
                    {
                        value: '是',
                        label: this.$t('getapi[2052]')//'是'
                    }
                ],
                scrollTop:0,
                btn:{
                    upd: true
                }
            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Pur/Order/DeliveryDateBatchFile?token=' + token;
        },
        mounted: function() {
            let that = this;
            that.vis = this.isVisible;
            that.userData = sessionStorage.getItem('userData');
            that.user = that.userData.username
            that.$refs.SetBtn.SetButtonEnable('');
            if(this.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                this.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[106]"),this.$t("getapi[16]"));
            },
            // 新物料打开
            showitems() {
                this.$refs.order.clearInput(true);
            },
            // 获取导入模板
            getTemplate() {
                let that = this
                that.$http.urlpost('/Pur/Order/ExportTemplate', '', function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            getorder(data) {
                let that = this
                for(let i = 0;i<data.length;i++){
                    that.dataSet = [...that.dataSet, {
                        exclusively_id: data[i].exclusively_id,
                        PO_Code: data[i].relation_po_code,
                        line_no: data[i].row_number,
                        Part_Code:data[i].part_code,
                        Part_version: data[i].part_version,
                        executor: data[i].exclusively_id,
                        old_date: data[i].plan_date,
                        new_date: "",
                        state: "可修改"
                    }]
                }
            },
            handleSelectionChange(val) {
                let that = this;
                for (let i = 0; i < val.length; i++) {
                    that.dataChecked.push(val[i].executor);
                }
            },
            tableRowClassName({row, rowIndex}) {                
                if (row.state != "可修改") {
                    return 'red';
                }
            },
            remove() {
                let that = this;
                let arr = that.dataSet.filter(item => {
                    return that.dataChecked.every(item2 => {
                        return item.executor != item2;
                    });
                });
                that.dataSet = arr;
            },
            handleChange(file, fileList) {
                let that = this;
                /*if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        console.log(file.response.DataContent)
                        that.dataSet = file.response.DataContent;
                    }
                }*/
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    let data = res.DataContent;
                    for(let i = 0;i<data.length;i++){
                        that.dataSet = [...that.dataSet, {
                            exclusively_id: data[i].exclusively_id,
                            PO_Code: data[i].PO_Code,
                            line_no: data[i].line_no,
                            Part_Code:data[i].Part_Code,
                            Part_version: data[i].Part_version,
                            executor: data[i].Executor,
                            old_date: data[i].old_date,
                            new_date: data[i].new_date,
                            state: data[i].state
                        }]
                    }
                    console.log(that.dataSet)
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            update() {
                let that = this;
                that.btn.upd = false
                let parm = []
                for( let i=0;i<that.dataSet.length;i++){
                    parm = [...parm, {
                        po_code: that.dataSet[i].PO_Code,
                        line_no: that.dataSet[i].line_no,
                        part_code: that.dataSet[i].Part_Code,
                        part_version: that.dataSet[i].Part_version,
                        old_date: that.dataSet[i].old_date,
                        new_date: that.dataSet[i].new_date,
                        executor: that.dataSet[i].executor,
                        LangType: that.$processdata.getLang(),
                    }]
                }
                that.$http.urlpost('/Pur/Order/DeliveryDateSave', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.btn.upd = true
                });
            }
        }
    };
</script>

<style scoped lang="less">
    .c-search-table {
        width: 100%;
        height: calc(~'100% - 10px'); /*这里我用了计算属性*/
    }

    .beauty-Scroll {
        .el-scrollbar {
            height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
        }
        .el-scrollbar__wrap {
            width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
            height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
        }
    }

    input {
        width: 100%;
        height: 35px;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        padding-left: 2px;
        padding-right: 2px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }

    .alignment-left {
        text-align: left;
    }

    .alignment-right {
        text-align: right;
    }

    .el-pagination {
        white-space: inherit;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
